// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"46bb093e","455":"4ea3cc46"}[chunkId] + ".chunk.js";
};